import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";
import CustomDropDown from "../CutomDropDown";
import Label from "../Label";
import TextInput from "../TextInputs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 0 10px 0",
  },
}));

let paramsData = {};

const AddEditUserDialog = forwardRef((props, ref) => {
  const {
    open,
    setOpen,
    allRoles,
    inputError,
    handleClose,
    inputValues,
    setInputValues,
    handleGetRoles,
    handleChageInputs,
    handleSelectOption,
    handleAddEditCategory,
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    handleGetRoles();
    console.log("🚀 ~ useEffect ~ handleGetRoles", allRoles);

    if (paramsData?.type !== "add") {
      const selectedRole = allRoles.find(
        (item) => item?.role === paramsData?.data?.role
      );
      setInputValues({
        firstName: paramsData?.data?.firstname,
        lastName: paramsData?.data?.lastname,
        contactNumber: paramsData?.data?.contactNumber,
        email: paramsData?.data?.email,
        password: paramsData?.data?.password,
        assingedRole: selectedRole ? selectedRole.role : "",
      });
      setShowPassword(false);
    }
  }, [paramsData]);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      setOpen(true);
      paramsData = params;
    },
  }));

  console.log(paramsData, "paramsDataparamsDataparamsData");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      scroll="body"
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        <DialogTitle sx={{ m: 0, p: 0 }} id="customized-dialog-title">
          {paramsData.type === "add" ? "New User" : "Edit User"}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <Label required labelText="First Name" htmlFor={"firstname"} />
            <TextInput
              required
              id={"firstName"}
              inputError={inputError.firstName}
              helperText={
                inputError.firstName ? "First Name is required" : null
              }
              placeholder={"Enter User Name"}
              name={"firstName"}
              value={inputValues.firstName}
              onChange={handleChageInputs}
            />
          </Grid>
          <Grid item xs={12}>
            <Label required labelText="Last Name" htmlFor={"lastname"} />
            <TextInput
              required
              id={"lastName"}
              inputError={inputError.lastName}
              helperText={inputError.lastName ? "Last Name is required" : null}
              placeholder={"Enter Last Name"}
              name={"lastName"}
              value={inputValues.lastName}
              onChange={handleChageInputs}
            />
          </Grid>
          <Grid item xs={12}>
            <Label required labelText="Contact Number" htmlFor={"contact"} />
            <TextInput
              required
              id={"contact"}
              inputError={inputError.contactNumber}
              helperText={
                inputError.contactNumber ? "Contact number is required" : null
              }
              placeholder={"Enter Contact Number"}
              name={"contactNumber"}
              value={inputValues.contactNumber}
              onChange={handleChageInputs}
            />
          </Grid>
          <Grid item xs={12}>
            <Label required labelText="Email" htmlFor={"email"} />
            <TextInput
              placeholder={"Enter Email"}
              inputError={inputError.email}
              helperText={
                inputError.email
                  ? "Email is required"
                  : inputError.isEmailValid
                  ? "Invalid email format"
                  : null
              }
              name={"email"}
              value={inputValues.email}
              onChange={handleChageInputs}
            />
          </Grid>

          {paramsData?.type == "add" && (
            <Grid item xs={12}>
              <Label required labelText="Password" htmlFor={"password"} />
              <TextInput
                required
                inputError={inputError.password}
                helperText={inputError.password ? "Password is required" : null}
                placeholder={"Enter Password"}
                type={showPassword ? "text" : "password"}
                name={"password"}
                disabled={paramsData?.type === "edit"}
                value={inputValues.password}
                onChange={handleChageInputs}
                InputEndIcon={
                  showPassword ? (
                    <Typography
                      variant="body2"
                      color={appcolors.black}
                      onClick={() => setShowPassword(false)}
                    >
                      Hide
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      color={appcolors.black}
                      onClick={() => {
                        if (paramsData?.type !== "edit") {
                          setShowPassword(true);
                        }
                      }}
                    >
                      Show
                    </Typography>
                  )
                }
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Label
              required
              labelText="Assigned Role"
              htmlFor={"assingedRole"}
            />
            <CustomDropDown
              value={inputValues.assingedRole}
              onChange={(event) => {
                handleSelectOption(event.target.value);
              }}
            >
              {allRoles.map((val, _ind) => (
                <MenuItem
                  key={_ind}
                  value={val.role}
                  sx={{
                    fontSize: "0.875rem",
                    color: val.type === "deleteShift" ? "red" : "inherit",
                  }}
                >
                  {val.role}
                </MenuItem>
              ))}
            </CustomDropDown>
            {inputError.assingedRole && (
              <Typography variant="body1" fontSize={12} color={"red"}>
                Role is required!
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"Cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={paramsData.type === "add" ? "Add User" : "Edit User"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={() =>
            handleAddEditCategory({
              ...inputValues,
              type: paramsData?.type,
              id: paramsData?.data?._id,
            })
          }
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditUserDialog;
